export const transactionChartDataTemplate = {
	chartId: '',
	labels: [],
	datasets: [
		{
			label: 'Delivered Orders',
			borderColor: 'rgba(0, 152, 218, 0.6)',
			pointBackgroundColor: '#FFFFFF',
			borderWidth: 1,
			pointBorderColor: '#ddd',
			backgroundColor: 'rgba(0, 152, 218, 0.6)',
			data: [],
		},
		{
			label: 'Total Orders',
			borderColor: 'rgba(0, 152, 218, 0.3)',
			pointBackgroundColor: '#FFFFFF',
			borderWidth: 1,
			pointBorderColor: '#ddd',
			backgroundColor: 'rgba(0, 152, 218, 0.3)',
			data: [],
		},
	],
};

export const commissionChartDataTemplate = {
	chartId: '',
	labels: [],
	datasets: [
		{
			label: 'Commission',
			borderColor: 'rgba(88, 192, 202, 0.6)',
			pointBackgroundColor: '#FFFFFF',
			borderWidth: 1,
			pointBorderColor: '#ddd',
			backgroundColor: 'rgba(242, 137, 0, 0.6)',
			data: [],
		},
	],
};

export const revenueChartDataTemplate = {
	chartId: '',
	labels: [],
	datasets: [
		{
			// backgroundColor: '#75cfd8',
			backgroundColor: '#0098DA',
			data: [],
		},
	],
};

export const customerChartDataTemplate = {
	chartId: 'customer',
	allCities: [],
	labels: [],
	datasets: [
		{
			backgroundColor: ['#47acb1', '#f2652d', '#f8aa7b', '#1abc9c', '#ef5350', '#a5a8aa', '#676766', '#add5d7', '#fee8af', '#fccd34'],
			data: [],
		},
	],
};
